"use strict";

exports.__esModule = true;
exports.default = createReduce;
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _keys2 = _interopRequireDefault(require("./keys.js"));
var _optimizeCb = _interopRequireDefault(require("./_optimizeCb.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal helper to create a reducing function, iterating left or right.
function createReduce(dir) {
  // Wrap code that reassigns argument variables in a separate function than
  // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
  var reducer = function reducer(obj, iteratee, memo, initial) {
    var _keys = !(0, _isArrayLike.default)(obj) && (0, _keys2.default)(obj),
      length = (_keys || obj).length,
      index = dir > 0 ? 0 : length - 1;
    if (!initial) {
      memo = obj[_keys ? _keys[index] : index];
      index += dir;
    }
    for (; index >= 0 && index < length; index += dir) {
      var currentKey = _keys ? _keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };
  return function (obj, iteratee, memo, context) {
    var initial = arguments.length >= 3;
    return reducer(obj, (0, _optimizeCb.default)(iteratee, context, 4), memo, initial);
  };
}